<template>
  <div id="home" class="home"></div>
</template>

<script>
import db from './../firebaseInit';

export default {
  name: 'home',
  title: 'Home',
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.home {
  /* background-color: red;

  @include breakpoint($mq-sm) {
    background-color: orange;
  }
  @include breakpoint($mq-md) {
    background-color: yellow;
  }
  @include breakpoint($mq-lg) {
    background-color: green;
  }
  @include breakpoint($mq-xlg) {
    background-color: blue;
  }
  @include breakpoint($mq-xxlg) {
    background-color: indigo;
  } */
}
</style>
